<template>
	<!-- Homologado con ui-select-snippet -->
	<div class="ui-select-snippet ui-input">
		<!--

            Version 3.13
		    Slot default y bottom-holder

            Version 3.12
		    Ahora permite el tipo small-float (n.nn)

            Version 3.11
		    Actualizado el formato de número con mobiscroll.numpad

            Version 3.10
		    Actualizado con slot name="default" en label.

            Version 3.9
		    Homologado de estilo con ui-select-snippet

			Version 3.8
			Se puede esconder la etiquta label con false boleano

			Version 3.7
			Actualización de CSS para checkbox

			Version 3.6
			CVV permite captura de tarjetas de Américan Express
            [type="card-americanexpress"]

			Version 3.5
			CVV permite 0 - 4 dígitos

			Version 3.4
			Metodología CARD, CARD-CVV, CARD-VIGENCY con Mobiscroll

			Version 3.3
			Metodología Number con Mobiscroll

			Version 3.2
			Metodología Phone con Mobiscroll

			Version 3.1
			Metodología Phone con Mobiscroll

			Version 3.0
			Se removió la función triggerModelUpdate en favor de v-model nativo.
			
			Version 2.1
			Hotfix en en textarea 

			Version 2.0
			Ahora permite el tipo textarea 
            -->
        <label v-if="label && label != 'false'" :for="workingId">
            <slot name="default">
                {{computedLabel}}
            </slot>
        </label>
		<textarea 			
			:id="workingId"
            rows="5"
			v-model="workingValue"
			v-if="type == 'textarea'"
            @blur="$emit('blur', $event)"
            @focus="$emit('focus', $event)"
            @change="$emit('change', $event, workingValue)"
            @keyup.enter="$emit('keyupEnter', $event);"
			:placeholder="placeholderAllowed"
			:pattern="patternAllowed"
			:maxlength="maxlengthAllowed"
			:disabled="readonlyAllowed"
			:class="{mobi: handledWithMobi}"
			:autocomplete="variableName">
		</textarea>
		<input v-else
			:id="workingId"
			v-model="workingValue"
			:placeholder="placeholderAllowed"
			:type="computedType"
			:pattern="patternAllowed"
			:maxlength="maxlengthAllowed"
			:disabled="readonlyAllowed"
			:class="{mobi: handledWithMobi}"
            @blur="$emit('blur', $event)"
            @focus="$emit('focus', $event)"
            @change="$emit('change', $event, workingValue)"
            @keyup.enter="$emit('keyupEnter', $event);"
			:autocomplete="variableName"
			/>
			<div v-if="type=='password'" @click="showingPass = !showingPass" class="pass-hint">
				<span v-if="!showingPass" key="a"> <i class="fa fa-eye-slash"></i></span>
				<span v-else key="b"> <i class="fa fa-eye"></i></span>
			</div>
            <div class="bottom-holder">
                <slot name="bottom"></slot>
            </div>
		<span class="mobi-text-holder" v-if="handledWithMobi">{{computedInputText}}</span>
	</div>
</template>

<script>
    import _ from "lodash";
    import mobiscroll from "@mobiscroll/javascript";
    import moment from "moment";
    moment.locale("en");
    export default {
        data() {
            return {
                workingId: null,
                showingPass: false,
                mobiInstance: null,
                variableName: null,
                workingValue: null
            };
        },
        props: {
            type: {
                type: [String],
                default: 'text'
            },
            label: {
                type: [String],
                default: null
            },
            value: {
                type: [String, Number],
                default: null
            },
            id: {
                type: [String],
                default: null
            },
            maxlength: {
                type: [String, Number],
                default: null
            },
            pattern: {
                type: [String, RegExp],
                default: null
            },
            placeholder: {
                type: [String],
                default: null
            },
            readonly: {
                type: [String, Number, Boolean],
                default: null
            },
            decimales: {
                type: Number,
                default: 0
            },
            min: {
                type: [String, Number],
                default: 0
            },
            max: {
                type: [String, Number],
                default: 99999999
            },
        },
        computed: {
            handledWithMobi() {
                let r = false;
                switch (this.type) {
                    case "date":
                    case "datetime":
                    case "time":
                        r = true;
                        break;
                }
                return r;
            },
            computedInputText() {
                // DATETIME
                if (this.type == "datetime" && this.value) {
                    return moment(this.value).format("dddd D, h:mm A");
                } else if (this.type == "datetime") {
                    return (this.placeholder) ? this.placeholder : "Fecha y hora";
                }

                // DATE
                else if (this.type == "date" && this.value) {
                    return moment(this.value).format("dddd D [de] MMMM, YYYY");
                } else if (this.type == "date") {
                    return (this.placeholder) ? this.placeholder : "Fecha";
                }

                // TIME
                else if (this.type == "time" && this.value) {
                    return moment(this.value).format("h:mm A");
                } else if (this.type == "time") {
                    return (this.placeholder) ? this.placeholder : "Hora";
                }

                // Default... Not quite used actually
                else {
                    return this.value;
                }
            },
            readonlyAllowed() {
                if (!!this.readonly) return this.readonly;
                else return null;
            },
            placeholderAllowed() {
                if (!!this.placeholder) return this.placeholder;
                else return null;
            },
            patternAllowed() {
                if (!!this.pattern) return this.pattern;
                else return null;
            },
            maxlengthAllowed() {
                if (!!this.maxlength) return this.maxlength;
                else return null;
            },
            computedLabel() {
                return !!this.label ? this.label : "Label";
            },
            computedType() {
                return ((!!this.type) && (!this.handledWithMobi) && (this.type == 'password' && !this.showingPass)) ? this.type : "text";
            },
        },
        methods: {

            loadMobiSmallFloat() {
                // Create a datepicker
                this.mobiInstance = mobiscroll.numpad("#" + this.workingId, {
                    headerText: this.label,
                    // preset: 'decimal',
                    scale: 2,
                    max: 99999999.99,
                    min: 0,
                    showOnFocus: true,
                    allowLeadingZero: true,
                    thousandsSeparator: '',
				    placeholder: "0",
                    decimal: {
                        scale: 0
                    },
                    onSet: (e, inst) => {
                        this.$emit("input", inst.getVal());
                    }
                });
            },

            linkMinAndMaxMobi() {
                if (this.handledWithMobi && !!this.mobiInstance) {
                    this.mobiInstance.option({
                        min: this.min,
                        max: this.max,
                    });
                }
            },
            loadMobiDatetime() {
                // Create a datepicker
                this.mobiInstance = mobiscroll.datetime("#" + this.workingId, {
                    headerText: this.label,
                    onSet: (e, inst) => {
                        this.$emit("input", inst.getVal());
                    },
                    steps: {
                        minute: 15,
                        second: 5,
                        zeroBased: true,
                    },
                    dateWheels: "|d|M|YY|",
                    timeWheels: "|h|ii|A|",
                });
                // this.mobiInstance.setVal(this.value);
                this.linkMinAndMaxMobi();
            },
            loadMobiDate() {
                // Create a datepicker
                this.mobiInstance = mobiscroll.date("#" + this.workingId, {
                    headerText: this.label,
                    onSet: (e, inst) => {
                        this.$emit("input", inst.getVal());
                    },
                    steps: {
                        minute: 30,
                        second: 5,
                        zeroBased: true,
                    },
                    dateWheels: "|DD d|MM|YY|",
                });
                //this.mobiInstance.setVal(this.value);
                this.linkMinAndMaxMobi();
            },
            loadMobiTime() {
                // Create a datepicker
                this.mobiInstance = mobiscroll.time("#" + this.workingId, {
                    headerText: this.label,
                    timeWheels: "|h|ii|A|",
                    circular: false,
                    onSet: (e, inst) => {
                        this.$emit("input", inst.getVal());
                    },
                    steps: {
                        minute: 30,
                        second: 5,
                        zeroBased: true,
                    },
                });
                // this.mobiInstance.setVal(this.value);
                this.linkMinAndMaxMobi();
            },
            loadMobiPhone() {
                // Create a datepicker
                this.mobiInstance = mobiscroll.numpad("#" + this.workingId, {
                    headerText: this.label,
                    fill: 'ltr',
                    template: '(ddd) ddd-dddd',
                    showOnFocus: true,
                    allowLeadingZero: true,
				    placeholder: "-",
                    // touchUi: false,
                    validate: function (event, inst) {
                        if (inst.isVisible()) {
                            // Display the formatted value
                            inst._markup[0].querySelector('.mbsc-np-dsp').innerHTML = inst.settings.formatValue(event.values, event.variables, inst) || '&nbsp;';
                        }
                        return {
                            // Set the set button invalid until 10 chars filled
                            invalid: event.values.length != 10
                        };
                    },
                    formatValue: function (numbers, variables, inst) {
                        // Specify how the value will be formatted
                        return (numbers.length > 2 ? '(' : '') + numbers.slice(0, 3).join('') + (numbers.length > 2 ? ') ' : '') + numbers.slice(3, 6).join('') + (numbers.length > 5 ? '-' : '') + numbers.slice(6, 10).join('');
                    },
                    parseValue: function (v, i) {
                        if (v) {
                            return v.replace('(', '').replace(') ', '').replace('-', '');
                        }
                    },
                    onSet: (e, inst) => {
                        this.$emit("input", inst.getVal());
                    }
                });
            },
            loadMobiCard() {
                // Create a datepicker
                this.mobiInstance = mobiscroll.numpad("#" + this.workingId, {
                    headerText: this.label,
                    fill: 'ltr',
                    template: 'dddd dddd dddd dddd',
                    showOnFocus: true,
                    allowLeadingZero: true,
				    placeholder: "-",
                    // step: 1,
                    onSet: (e, inst) => {
                        this.$emit("input", inst.getVal());
                    }
                });
            },
            loadMobiAmericanExpressCard() {
                // Create a datepicker
                this.mobiInstance = mobiscroll.numpad("#" + this.workingId, {
                    headerText: this.label,
                    fill: 'ltr',
                    template: 'dddd dddddd ddddd',
                    showOnFocus: true,
                    allowLeadingZero: true,
				    placeholder: "-",
                    // step: 1,
                    onSet: (e, inst) => {
                        this.$emit("input", inst.getVal());
                    }
                });
            },
            loadMobiCode() {
                // Create a datepicker
                this.mobiInstance = mobiscroll.numpad("#" + this.workingId, {
                    headerText: this.label,
                    fill: 'ltr',
                    template: 'ddd ddd',
                    showOnFocus: true,
                    allowLeadingZero: true,
				    placeholder: "-",
                    // step: 1,
                    onSet: (e, inst) => {
                        this.$emit("input", inst.getVal());
                    }
                });
            },
            loadMobiCardVigency() {
                // Create a datepicker
                this.mobiInstance = mobiscroll.numpad("#" + this.workingId, {
                    headerText: this.label,
                    fill: 'ltr',
                    template: 'dd/dd',
                    showOnFocus: true,
                    allowLeadingZero: true,
				    placeholder: "-",
                    // step: 1,
                    onSet: (e, inst) => {
                        this.$emit("input", inst.getVal());
                    }
                });
            },
            loadMobiCardCVV() {
                // Create a datepicker
                this.mobiInstance = mobiscroll.numpad("#" + this.workingId, {
                    headerText: this.label,
                    preset: 'decimal',
                    scale: 0,
                    max: 9999,
                    min: 0,
                    showOnFocus: true,
                    allowLeadingZero: true,
                    thousandsSeparator: '',
				    placeholder: "-",
                    decimal: {
                        scale: false
                    },
                    onSet: (e, inst) => {
                        this.$emit("input", inst.getVal());
                    }
                });
            },
            loadMobiNumber() {
                // Create a datepicker
                this.mobiInstance = mobiscroll.numpad("#" + this.workingId, {
                    headerText: this.label,
                    // fill: 'ltr',
                    // template: 'ddddddddddd',
                    showOnFocus: true,
                    preset: 'decimal',
                    decimalSeparator: '.',
                    thousandsSeparator: '´',
                    scale: this.decimales,
                    min: this.min,
                    max: this.max,
                    // allowLeadingZero: false,
                    step: 1,
                    onSet: (e, inst) => {
                        this.$emit("input", inst.getVal());
                    }
                });
            },
        },
        watch: {
            workingValue(){
                this.$emit('input', this.workingValue)
            },
            value() {
                if (this.handledWithMobi && !!this.mobiInstance) {
                    this.mobiInstance.setVal(this.value);
                } else {
                    this.workingValue = this.value
                }
            },
            min() {
                this.linkMinAndMaxMobi();
            },
            max() {
                this.linkMinAndMaxMobi();
            },
        },
        beforeMount(){
            this.workingValue = _.clone(this.value)
        },
        mounted() {
            if (!this.id) {
                this.workingId = _.uniqueId("ui-select-snippet-");
            } else {
                this.workingId = this.id
            }
            this.variableName = _.uniqueId("___");
            if (this.type == "datetime") setTimeout(this.loadMobiDatetime, 10);
            else if (this.type == "date") setTimeout(this.loadMobiDate, 10);
            else if (this.type == "time") setTimeout(this.loadMobiTime, 10);
            else if (this.type == "phone") setTimeout(this.loadMobiPhone, 10);
            else if (this.type == "number") setTimeout(this.loadMobiNumber, 10);
            else if (this.type == "code") setTimeout(this.loadMobiCode, 10);
            else if (this.type == "card") setTimeout(this.loadMobiCard, 10);
            else if (this.type == "small-float") setTimeout(this.loadMobiSmallFloat, 10);
            else if (this.type == "card-americanexpress") setTimeout(this.loadMobiAmericanExpressCard, 10);
            else if (this.type == "card-vigency") setTimeout(this.loadMobiCardVigency, 10);
            else if (this.type == "card-cvv") setTimeout(this.loadMobiCardCVV, 10);
        }
    };
</script>